import { UiService } from '@services/ui.service';
import { OrdersService } from '@services/orders.service';
import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface DialogData {
  orderId: string
}

@Component({
  selector: 'app-dialog-change-timespent',
  templateUrl: './dialog-change-timespent.component.html',
  styleUrls: ['./dialog-change-timespent.component.scss']
})
export class DialogChangeTimespentComponent implements OnInit {
  form = new UntypedFormGroup({
    timeSpent: new UntypedFormControl(null, Validators.required)
  });

  constructor(
    public dialogRef: MatDialogRef<DialogChangeTimespentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private ordersSrv: OrdersService,
    protected uiSrv: UiService
  ) { }

  onNoClick(): void {
    this.dialogRef.close();
  }

  ngOnInit(): void {
  }

  confirm(): void {
    let hours = parseInt(this.form.value.timeSpent.split(':')[0]);
    let minutes = parseInt(this.form.value.timeSpent.split(':')[1]);

    let total = hours * 60 + minutes;

    this.ordersSrv.changeTimeSpent(this.data.orderId, total)
      .subscribe(() => {
        this.uiSrv.showSnackbar('orders.list.timeSpentChanged', true);
        this.onNoClick();
      })
  }
}
